// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1Qds8","alertIcon":"ConfirmModal_alertIcon__3Xkkp"};